import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GuideType = {
   typeid: string;
   name: string;
};

export type GetGuideTypeOptionsRequestOptions = CommonRequestOptions;

export type GetGuideTypeOptionsResponse = {
   types: GuideType[];
   default_typeid: string;
};

export async function getGuideTypeOptions(
   common: GetGuideTypeOptionsRequestOptions = {}
): Promise<GetGuideTypeOptionsResponse> {
   return makeRequest('get', `guides/typeOptions`, {
      ...common,
   });
}
